import { render, staticRenderFns } from "./goa-taxi-booking.vue?vue&type=template&id=6bfb579f&scoped=true"
import script from "./goa-taxi-booking.vue?vue&type=script&lang=js"
export * from "./goa-taxi-booking.vue?vue&type=script&lang=js"
import style0 from "./goa-taxi-booking.vue?vue&type=style&index=0&id=6bfb579f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfb579f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TaxiCard: require('/workspace/components/TaxiCard.vue').default,FaqCard: require('/workspace/components/FaqCard.vue').default})
